export default __webpack_public_path__ + "static/media/fvrt.ecc3dfda.svg";